import React from "react";
import "./LoginScreens.scss";
import Login from "../../components/LoginScreens/Login/Login";
import ResetPassword from "../../components/LoginScreens/ResetPassword/ResetPassword";
import SignUp from "../../components/LoginScreens/SignUp/SignUp";
import CreateAccount from "../../components/LoginScreens/CreateAccount/CreateAccount";
import ForgotPassword from "../../components/LoginScreens/ForgotPassword/ForgotPassword";
import loginScreenImage from "../../assets/Images/login-screen-image.svg";

export const loginScreensMapping = {
  "/login": <Login />,
  "/reset-password": <ResetPassword />,
  "/sign-up": <SignUp />,
  "/create-account": <CreateAccount />,
  "/forgot-password": <ForgotPassword />,
};

export default class LoginScreens extends React.Component {
  getCardContent = () => {
    const mapping = {
      login: <Login />,
      "reset-password": <ResetPassword {...this.props} />,
      "sign-up": <SignUp />,
      "create-account": <CreateAccount {...this.props} />,
      "forgot-password": <ForgotPassword />,
    };

    const location = this.props.location;
    return mapping[location.pathname.split("/")[1]];
  };

  render() {
    return (
      <div className="container-fluid login-wraper">
        <div className="col image-content">
          <img src={loginScreenImage} alt="" />
          <h3 className="title">
            Discover a better way to have organizational alignment
          </h3>
          <p className="details">
            Get rid of endless email chains, bloated spreadsheets, and
            labyrinthine folder structures. Tikler streamlines every aspect of
            the document management process.
          </p>
        </div>

        <div className="col login-content">
          <div className="login-screen-card">{this.getCardContent()}</div>
        </div>
      </div>
    );
  }
}
